type RadioButtonProps = React.ComponentPropsWithoutRef<'button'>

export const RadioButton = ({
  children,
  ...buttonProps
}: RadioButtonProps): JSX.Element => (
  <button
    className='group font-light p-4 rounded-xl flex items-center border-2 hover-hover:hover:bg-brand-light-purple hover-hover:hover:border-brand-light-purple hover-hover:hover:bg-opacity-50 hover-hover:hover:border-opacity-30 active:bg-brand-light-purple active:border-brand-light-purple active:bg-opacity-50 active:border-opacity-30'
    {...buttonProps}
  >
    <span className='appearance-none border-4 h-5 w-5 mr-2 rounded-full bg-gray-200 hover-hover:group-hover:border-white hover-hover:group-hover:bg-brand-light-purple hover-hover:group-hover:bg-opacity-5 group-active:border-white group-active:bg-brand-light-purple group-active:bg-opacity-5' />
    <span>{children}</span>
  </button>
)
